export type TrackClickOptions = {
  openInNewWindow?: boolean;
  openInCurrentWindow?: boolean;
  selectedType: string;
  count: number;
};

export interface OmnisearchResult {
  link: string;
  name: string;
  type: OmnisearchResultType;
}

export enum OmnisearchResultType {
  Campaign = `ENTITY_TYPE_CAMPAIGN`,
  Cohort = `ENTITY_TYPE_COHORT`,
  Dashboard = `ENTITY_TYPE_DASHBOARD`,
  Event = `ENTITY_TYPE_EVENT`,
  Help = `ENTITY_TYPE_HELP`,
  Message = `ENTITY_TYPE_MESSAGE`,
  Report = `ENTITY_TYPE_REPORT`,
}

export const enum ResultOrder {
  Report,
  Dashboard,
  Cohort,
  Message,
  Help,
  Campaign,
  Event,
}

export interface OmnisearchResultViewElements {
  icon: string;
  name: string;
  plural: string;
  order: number;
}

export type ProjectOrWorkspace = {projectId: number; workspaceId: number};
